module.exports = __webpack_public_path__ + "img/team_3.22142c42.jpg";